import { useQuery } from "@hooks/useQuery";
import { Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { DynamicForm, FormConfig } from "~/Components/DynamicForm/DynamicForm";
import { FieldValues } from "react-hook-form";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { centralizedHost, corporateHost, eramanHost } from "~/Utils";
import { useNotification } from "~/Hooks/useNotification";
import { post, put } from "~/Services";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../constants";
import { useGuidelinesForCheckedinLuggageSection1 } from "../TravellersInfo.hook";

export const CentralizedGuidelinesForCheckedInSection1 = () => {
  const { openToast } = useNotification();
  const query = useQuery();
  const navigate = useNavigate();
  const subActiveTab = query.get('subActiveTab');

  const { data: singleCabinLuggagePolicy, isLoading: isLoadingSingleCabinLuggagePolicy, refetch: refetchsingleCabinLuggagePolicy } = useGuidelinesForCheckedinLuggageSection1();
  const { data: travellersInfoById, isLoading: isLoadingTravellersInfoById, refetch: refetchDocument } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get('id')) {
      refetchDocument();
    } else {
      refetchsingleCabinLuggagePolicy();
    }
  }, [query.get("id")])

  const singleCabinLuggagePolicyFormConfig: FormConfig = {
    initialValues: {
      tab_title_english : travellersInfoById ? decodeHTML(travellersInfoById.payload.tab_title_english) : singleCabinLuggagePolicy ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_english) : "",
      tab_title_malay : travellersInfoById ? decodeHTML(travellersInfoById.payload.tab_title_malay) : singleCabinLuggagePolicy ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_malay) : "",
      tab_title_mandarin : travellersInfoById ? decodeHTML(travellersInfoById.payload.tab_title_mandarin) : singleCabinLuggagePolicy ? decodeHTML(singleCabinLuggagePolicy?.[0].tab_title_mandarin) : "",
      title: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.title)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.title)
          : "",
      title_malay: travellersInfoById ? decodeHTML(travellersInfoById.payload.title_malay) : singleCabinLuggagePolicy ? decodeHTML(singleCabinLuggagePolicy?.[0].title_malay) : "",
      title_mandarin: travellersInfoById
        ? decodeHTML(travellersInfoById.payload.title_mandarin)
        : singleCabinLuggagePolicy
          ? decodeHTML(singleCabinLuggagePolicy?.[0]?.title_mandarin)
          : "",
    },
    fields: fields.centralizedGuidelinesForCheckedinLuggagePageContent
  }


  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {

    let imageKeys: any = [
      "image",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CENTRALIZED");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) { }
    }

    const payload = {
      action: action,
      method: method,
      module: "Baggage Guide",
      subModule: "centralizedGuidelinesForCheckedinLuggage_centralizedGuidelinesForCheckedinLuggagePageContent",
      type: "CENTRALIZED",
      application: "CENTRALIZED",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "CENTRALIZED",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: singleCabinLuggagePolicy?.[0]?.id || travellersInfoById?.payload?.id }),
        ...data,
        published: true,
      },
      status: status,
    };
    console.log(payload,"payload")
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/centralized/status-information?activeTab=pending");
          } else {
            navigate("/centralized/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };


  return (
    // <ContentWrapper>
    <DynamicForm
      isLoading={isLoadingSingleCabinLuggagePolicy || isLoadingTravellersInfoById}
      config={singleCabinLuggagePolicyFormConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${centralizedHost}/api/baggage/checked-in/section-one/${singleCabinLuggagePolicy?.[0]?.id || travellersInfoById?.payload?.id}`,
          "UPDATE",
          "PATCH",
          buttonValue === "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
      defaultReviewNotes="Kindly review this Baggage Guide"
    />
    // </ContentWrapper>
  );
};
